export default __webpack_public_path__ + "static/media/clock-circle.e38a45b4.svg";